var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00503 14.25H4.89262C5.87416 14.25 6.7802 13.8775 7.45973 13.207L13.5 7.09768L12.9715 6.57616L12.443 6.05464L10.4799 4.04305L9.87584 3.52152L9.34732 3L3.30705 9.10927C2.62752 9.7798 2.25 10.6738 2.25 11.6424V13.505C2.25 13.952 2.55201 14.25 3.00503 14.25Z",
    fill: "#868686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5173 3.09122L13.4066 5.00676L13.9152 5.50338L14.4239 6L14.9325 5.50338C16.0225 4.43919 16.0225 2.66554 14.9325 1.60135C14.4239 1.03378 13.6972 0.75 12.9706 0.75C12.2439 0.75 11.5173 1.03378 11.0087 1.53041L10.5 2.02703L11.0087 2.52365L11.5173 3.09122Z",
    fill: "#868686"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75H2.25C1.8 15.75 1.5 16.05 1.5 16.5C1.5 16.95 1.8 17.25 2.25 17.25H15.75C16.2 17.25 16.5 16.95 16.5 16.5C16.5 16.05 16.2 15.75 15.75 15.75Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.a6adf18710b61066944e4a09044f9759.svg";
export { ForwardRef as ReactComponent };